import { useEffect, useState } from "react";
import { isValidElement } from "react";
import PubSub from "../../services/PubSub";
import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const InfoModal = () => {
    const [translate] = useTranslation();
    const [show, setShow] = useState(false);
    const [info, setInfo] = useState("");
    const [title, setTitle] = useState("OTM_ERROR");
    const [extraInfo, setExtraInfo] = useState("");
    const [messages, setMessages] = useState(null);

    useEffect(() => {
        const showId = PubSub.subscribe("show_info", (error, title, shouldTranslate = true, errorSubCode) => {
            if (Array.isArray(error)) {
                setMessages(error);
                setInfo("");
                setExtraInfo("");
            } else {
                setInfo(shouldTranslate ? translate(error) : error);
                setExtraInfo(translate(errorSubCode));
                setMessages(null);
            }
            
            if (title) {
                setTitle(title);
            }
            setShow(true);
        });

        return () => {
            PubSub.unsubscribe("show_info", showId);
        }
    }, [translate]);

    const renderBody = () => {
        if (messages !== null) {
            return messages.map((msg, index) => {
                if (isValidElement(msg)) {
                    return <div key={index}>{msg}</div>;
                }
                return <label key={index} className="d-block">{msg}</label>;
            });
        }
        
        return (
            <>
                <label>{info}</label>
                <label className='d-block'>{extraInfo}</label>
            </>
        );
    };

    return (
        <BootstrapModal show={show} backdrop="static">
            <BootstrapModal.Header className="h5 text-secondary">{translate(title)}</BootstrapModal.Header>
            <BootstrapModal.Body>
                {renderBody()}
            </BootstrapModal.Body>
            <BootstrapModal.Footer>
                <Button onClick={() => setShow(false)} variant="secondary" className="btn-sm">{translate("OTM_CLOSE")}</Button>
            </BootstrapModal.Footer>
        </BootstrapModal>
    );
};

export default InfoModal;